import MapMaker from "../utils/MapMaker";
import {gsap} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class FilterSelect {
    static init() {
        this.filters = document.querySelectorAll(".filter-jobs select");
        this.filterReset = document.querySelector(".listing-filters-reset");
        this.jobsCards = document.querySelectorAll(".card-job-offer");
        this.map = document.querySelector('.listing-map-inner');
        this.form = document.querySelector('.single-form');

        if (this.filters.length) {
            this.filterResetHeight();
            this.initFilterSelect();
            this.initFiltersReset();
        }

        if (this.map) {
            this.initJobsMap();
            GlobalVariables.resizeCallbacks.push(this);
        }

        if (this.form) {
            this.initScrollToForm();
        }


    }

    static filterResetHeight() {
        const height = this.filterReset.offsetHeight;
        this.filterReset.style.setProperty("--height", `${height}px`);
        this.filterReset.classList.add("inactive");

    }

    static initFiltersReset() {
        this.filterReset.addEventListener("click", (e) => {
            this.filters.forEach(select => {
                select.selectedIndex = 0;
            });
            this.filterReset.classList.add("inactive");
            this.jobsCards.forEach(card => {
                card.classList.add("active");
            });
        });
    }

    static initFilterSelect() {
        function allValuesAreAll(arr) {
            return arr.every(item => item.value === "all");
        }

        this.filters.forEach(filter => {
            filter.addEventListener("change", (e) => {
                let filterValues = [];
                this.filters.forEach(filter => {
                    if (filter.value) {
                        filterValues.push({
                            key: filter.name,
                            value: filter.value
                        });
                    }
                });

                this.jobsCards.forEach(card => {
                    let isMatch = true;

                    filterValues.forEach(filter => {
                        const datasetKey = filter.key;
                        const cardValue = card.dataset[filter.key];

                        if (filter.value !== "all" && cardValue !== filter.value) {
                            isMatch = false;
                        }
                    });

                    if (isMatch) {
                        card.classList.add("active");
                    } else {
                        card.classList.remove("active");
                    }
                });

                if (allValuesAreAll(filterValues)) {
                    this.filterReset.classList.add("inactive");
                } else {
                    this.filterReset.classList.remove("inactive");
                }
            });
        });
    }

    static initJobsMap() {
        window.addEventListener("googleMapApiLoaded", () => {
            let markers = this.map.querySelectorAll('.map-marker');
            this.jobsMap = MapMaker.createDynamicMap(this.map);

            if (this.map.dataset.zoom) {
                this.jobsMap.setZoom(parseInt(this.map.dataset.zoom));
            }

            markers.forEach((m) => {
                MapMaker.createMarker(m, this.jobsMap);
            });

            if (this.jobsMap.markers.length > 1) {
                this.jobsMap.fitBounds(this.jobsMap.bounds);
            } else {
                this.jobsMap.setCenter(this.jobsMap.markers[0].position);
            }

            if (this.map.dataset.markerClusterer === "true") {
                MapMaker.initMarkerClusterer(this.jobsMap);
            }
        });
    }

    static initScrollToForm() {
        const formContainer = this.form.querySelector(".inner");
        const btnContainer = form.querySelector(".single-form-btn-container");

        gsap.to(btnContainer, {
            opacity: 1,
            scrollTrigger: {
                trigger: formContainer,
                start: "bottom 20%",
                scrub: true,
                ease: "power2.out"
            }
        });
    }

    static resize() {
        if (this.jobsMap.markers.length > 1) {
            this.jobsMap.fitBounds(this.jobsMap.bounds);
        } else {
            this.jobsMap.setCenter(this.jobsMap.markers[0].position);
        }
    }
}
